export default __webpack_public_path__ + "static/media/review-sample-photo-2.c32b709b.jpg";